export default __webpack_public_path__ + "static/media/fitness.fe46289b.jpg";